import React from 'react';
import './FooterAdmin.css';

const FooterAdmin = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="hd-admin-footer">
      <span>© {currentYear} Home Deco. Espace administration.</span>
    </footer>
  );
};

export default FooterAdmin;
